import AppBar from '@mui/material/AppBar';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid';
import { ButtonBase, useMediaQuery, useTheme } from '@mui/material'
import * as React from 'react';

import { Link as RouterLink } from "react-router-dom";
import { AppRoutes } from './constants/routes';
import { useAuthProvider } from "./utils/auth";
import SearchGeneric from './components/SearchItemComp/SearchGeneric';
import ProfileMenu from './components/ProfileMenu/ProfileMenu';
import SideMenuMusicCon from './components/SideMenuContent/SideMenuMusicContent';
import NotificationDropdown from './components/NotificationDropdown';
import MessagesDropdown from './components/MessagesDropdown';
import ActingAsSwitcher from './components/ActingAsSwitcher';
import Logo from './components/Logo/Logo';

export default function SimpleBottomNavigation() {
  const { isAuthed, userType, isListening, dashboardRoute } = useAuthProvider();
  // Listening UI (search, credit, listening nav): visitors, and anyone in the
  // listening experience - not account dashboards
  const showListeningUI = !isAuthed || isListening;
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };

  /*const doLogout = (e) => {
    deauthorizeUser().then(() => {
      navigate("/");
    });
  }*/

  const yellowButton = {
    textTransform: 'none',
    width: isMobile ? "4rem" : "5rem",
    fontSize: isMobile ? "0.75rem" : "0.875rem",
    minWidth: isMobile ? "60px" : "80px",
    height: isMobile ? "32px" : "36px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }


  return (

    <AppBar
      position="fixed"
      color="default"
      sx={{
        paddingBottom: isMobile ? '6px' : '8px',
        paddingTop: isMobile ? '6px' : '8px',
        mb: 0,
        boxShadow: 2,
        minHeight: isMobile ? '52px' : '60px',
        display: 'flex',
        alignItems: 'center',
        color: 'text.primary',
        backgroundColor: 'background.paper', // Explicitly set to match theme
      }}
    >
      <Grid
        container
        spacing={0}
        justifyContent="space-between"
        alignItems="center"
        wrap="nowrap"
        sx={{ columnGap: { xs: 1, md: 2 } }}
      >
        <Grid item sx={{ flexShrink: 0 }}>
          <Grid container alignItems="center" spacing={1}>
            {/* Show side menu for listeners, creators in listening mode, labels in listening mode, and publishers in listening mode */}
            {showListeningUI && (
              <Grid item>
                <SideMenuMusicCon
                mobileOpen={mobileOpen}
                handleDrawerToggle={handleDrawerToggle}
                handleDrawerClose={handleDrawerClose}
                />
              </Grid>
            )}
            {isAuthed && showListeningUI && (
              <>
                {/* Playlist management buttons moved to left menu for listeners */}
              </>
            )}
            <Grid item>
              <ButtonBase 
                component={RouterLink} 
                to={
                  !isAuthed ? AppRoutes.Home1 : 
                  !isListening ? dashboardRoute :
                  AppRoutes.Home2
                }
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: muiTheme.palette.background.paper, // Use theme value directly
                  '&:hover': {
                    backgroundColor: muiTheme.palette.background.paper, // Keep same background on hover
                  },
                  '&:focus': {
                    backgroundColor: muiTheme.palette.background.paper, // Keep same background on focus
                  },
                }}
              >
                <Logo />
              </ButtonBase>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs sx={{ minWidth: 0, overflow: 'hidden' }}>
          <Grid container justifyContent="center">
            {/* Show search for listeners, creators in listening mode, labels in listening mode, publishers in listening mode, and podcasters on desktop */}
            {(showListeningUI || userType === 'podcaster') && !isMobile && <SearchGeneric/>}
          </Grid>
        </Grid>

        <Grid item sx={{ flexShrink: 0 }}>
        <Grid container alignItems="center" justifyContent="flex-end" spacing={isMobile ? 0.5 : 1} sx={{ pr: isMobile ? 1 : 2 }}>
          {isAuthed ?
            <span />
            :
            <>
              <Fab
                color="primary"
                variant="extended"
                size={isMobile ? "small" : "small"}
                component={RouterLink}
                to={AppRoutes.SignupInitial}
                sx={ yellowButton }
              >{isMobile ? "Sign up" : "Sign up"}</Fab>
            </>
          }


          {isAuthed ?
            /*<Fab
              variant="extended"
              size="small"
              component={RouterLink}
              to={AppRoutes.LoginPage}
              sx={ yellowButton }
              onClick={doLogout}
            >Log out</Fab>*/
            <Grid item sx={{ display: 'flex', alignItems: 'center', height: '100%', mr: isMobile ? 0.5 : 1, gap: 1 }}>
              {/* Who you're acting as: yourself listening, or a dashboard -
                  your own, or a label or publisher you run */}
              <ActingAsSwitcher />
              {/* Show notifications for all authenticated users */}
              <NotificationDropdown />
              {/* Show messages for all authenticated users */}
              <MessagesDropdown />
              <ProfileMenu/>
            </Grid>
            :
            <Fab
              variant="extended"
              size={isMobile ? "small" : "small"}
              component={RouterLink}
              to={AppRoutes.LoginPage}
              sx={{ 
                textTransform: 'none', 
                marginLeft: isMobile ? '.25rem' : '.5rem',
                width: isMobile ? "4rem" : "5rem",
                fontSize: isMobile ? "0.75rem" : "0.875rem",
                minWidth: isMobile ? "60px" : "80px",
                height: isMobile ? "32px" : "36px",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >{isMobile ? "Log in" : "Log in"}</Fab>
          }

          </Grid>
        </Grid>
        
      </Grid>

    </AppBar>

  );
}
